import { Input } from "@/components/ui/input";
import { formatNOK } from "@/lib/format";
import type { PreviewMetadata } from "@/hooks/use-import-preview";

interface ImportSummaryCardProps {
  metadata: PreviewMetadata;
  onChange: (next: PreviewMetadata) => void;
}

/**
 * Header-kort over preview-tabellen: lar PL justere overhead %, rabatt %,
 * rabatt kr inline, og viser tilbudssum-fra-parser som referanse.
 */
export function ImportSummaryCard({ metadata, onChange }: ImportSummaryCardProps) {
  return (
    <div className="mb-3 grid grid-cols-2 sm:grid-cols-4 gap-2 px-3 py-2 rounded-md border border-border bg-muted/30">
      <label className="flex flex-col gap-1">
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground">
          Overhead %
        </span>
        <Input
          type="number"
          step="0.5"
          className="h-8 px-2 text-sm tabular-nums"
          value={metadata.overhead_pct}
          onChange={(e) =>
            onChange({ ...metadata, overhead_pct: Number(e.target.value) })
          }
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground">
          Rabatt %
        </span>
        <Input
          type="number"
          step="0.5"
          className="h-8 px-2 text-sm tabular-nums"
          value={metadata.discount_pct}
          onChange={(e) =>
            onChange({ ...metadata, discount_pct: Number(e.target.value) })
          }
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground">
          Rabatt kr
        </span>
        <Input
          type="number"
          className="h-8 px-2 text-sm tabular-nums"
          value={metadata.discount_amount || ""}
          onChange={(e) =>
            onChange({ ...metadata, discount_amount: Number(e.target.value) })
          }
        />
      </label>
      <label className="flex flex-col gap-1">
        <span className="text-[10px] uppercase tracking-wider text-muted-foreground">
          Tilbudssum (parsed)
        </span>
        <span className="h-8 px-2 flex items-center text-sm tabular-nums text-muted-foreground">
          {metadata.offer_total > 0 ? formatNOK(metadata.offer_total) : "—"}
        </span>
      </label>
    </div>
  );
}
